import { render, staticRenderFns } from "./UserChangePassword.vue?vue&type=template&id=f9a8e300&scoped=true"
import script from "./UserChangePassword.vue?vue&type=script&lang=js"
export * from "./UserChangePassword.vue?vue&type=script&lang=js"
import style0 from "./UserChangePassword.vue?vue&type=style&index=0&id=f9a8e300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a8e300",
  null
  
)

export default component.exports